import React, {useEffect, useState} from "react";
import {
    Autocomplete,

    Box, Button,
    Container, Drawer, FormControl,
    Grid, InputLabel, Modal,
    Paper, Select, Stack,
} from "@mui/material";
import MainLayout from "../MainLoyout/MainLayout";

import Title from "../Title";
import Api from "../../Services/Api";
import {DataGrid, GridActionsCellItem, GridToolbar} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import MenuItem from "@mui/material/MenuItem";
import {useSelector} from "react-redux";
import Success from "../Snackbar/Success";
import TextField from "@mui/material/TextField";
import {check, updateDemandFeeds, updateSupplyFeeds} from "../../features/users/Users";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import Typography from "@mui/material/Typography";
import BasicModalTable from "../BasicModalTable";
import {DatePicker} from "@mui/x-date-pickers-pro";
import IconButton from "@mui/material/IconButton";
import {ContentCopy, QueryStats, Refresh} from "@mui/icons-material";
import {useLocation, useSearchParams} from "react-router-dom";
import SupplyFeedDetailsTable from "./SupplyFeedDetailsTable";


const SupplyAdmin = () => {

    const [supplyStats, setSupplyStats] = React.useState([]);

    const [apiMessage, setApiMessage] = React.useState(null);

    const [loading, setLoading] = React.useState(true);
    const [pageSize, setPageSize] = React.useState(100);
    const [rowsModalTable, setRowsModalTable] = React.useState([]);
    const [columnsModalTable, setColumnsModalTable] = React.useState([]);
    const [openModal, setOpenModal] = React.useState(false);
    const [loadingModal, setLoadingModal] = React.useState(true);
    const [startDate, setStartDate] = React.useState(null);
    const [openDetails, setOpenDetails] = React.useState(false);
    const [detailsId, setDetailsId] = React.useState(null);

    let [searchParams, setSearchParams] = useSearchParams();



    useEffect(() => {

        let data = null;

        if(searchParams.get('start_date'))
        {
            data = {start_date: searchParams.get('start_date')}
        }

        loadStats(data)

    }, []);

    const loadStats = async (data) => {
        setLoading(true)
        console.log(data)
        if(data)
        {
            searchParams.set('start_date', data.start_date)
            setStartDate(data.start_date)
            setSearchParams(searchParams)
        }


        await Api.adminSupply(data).then(r => {
            setSupplyStats(Object.values(r))
        })

        setLoading(false)
    }

    const handleModal = (id, type) => {

        setLoadingModal(true)
        const found = supplyStats.filter(item => item.id == id)
        const referers = JSON.parse(found[0].daily_stats[0].referers)
        let data = []
        if (type == "referers") {


            Object.keys(referers).map(key => {
                if (key == "") {
                    data.push({referer: "None", id: "None", searches: referers[key]})
                } else {
                    data.push({referer: key, id: key, searches: referers[key]})
                }
            })
            setRowsModalTable(data)
            setColumnsModalTable([{
                field: "referer",
                headerName: "Referer",
                type: 'string',
                editable: false,
                flex: 0.5,

            },
                {
                    field: "searches",
                    headerName: "Searches",
                    type: 'number',
                    editable: false,
                    flex: 0.2,


                }
            ])
            setOpenModal(true)
            setLoadingModal(false)
        } else if( type == "keywords") {

            setColumnsModalTable([{
                field: "keyword",
                headerName: "keyword",
                type: 'string',
                editable: false,
                flex: 0.5,

            },
                {
                    field: "searches",
                    headerName: "Searches",
                    type: 'number',
                    editable: false,
                    flex: 0.2,

                }
            ])

            setOpenModal(true)
            Api.supplyKeywords({id: found[0].id, date: found[0].daily_stats[0].date}).then(r => {
                setRowsModalTable(r)
                setLoadingModal(false)

            })
        }


    }

    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );

    const formatNumber = (value) => {
        if (isNaN(value) || value === null) return 0
        const valueFormatted = parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        return `${valueFormatted}`;
    }

    const columns = [
        {
            field: "id",
            headerName: "Id",
            type: 'number',
            editable: false,
            flex: 0.1,
            minWidth: 50

        },
        {
            field: "publisher",
            headerName: "Publisher",
            type: 'string',
            editable: false,
            flex: 0.2,
            minWidth: 100,
            valueGetter: (params) => params.row?.user?.name

        },
        {
            field: "demand",
            headerName: "Demand",
            type: 'string',
            editable: false,
            flex: 0.2,
            minWidth: 100,
            valueGetter: (params) => params.row?.daily_stats.length ? params.row?.daily_stats[0].demand_feed.user.name:"-"

        },
        {
            field: "searches",
            headerName: "Searches",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 100,
            valueGetter: (params) => params.row?.daily_stats.length ? params.row?.daily_stats[0].searches : 0


        },
        {
            field: "unique_keywords",
            headerName: "U.Key %",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 100,
            valueGetter: (params) => params.row?.daily_stats.length ? params.row?.daily_stats[0].unique_keywords / params.row?.daily_stats[0].searches : 0,
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value * 100)
                return valueFormatted + "%"
            },
            renderCell: (params) => <a href={"#keywords"} onClick={() => handleModal(params.row.id, 'keywords')}>{params.row?.daily_stats.length ? formatNumber(params.value * 100)+"%": "0%"}</a>

        },
        {
            field: "opticks_fraud_rate",
            headerName: "Fraud %",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 100,
            valueGetter: (params) => params.row?.daily_stats.length && params.row?.daily_stats[0].opticks_fraud_rate ? params.row?.daily_stats[0].opticks_fraud_rate : 0,
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value * 100)
                return valueFormatted + "%"
            }

        },
        {
            field: "service_words",
            headerName: "S. Kwd %",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 50,
            valueGetter: (params) => params.row?.daily_stats.length && params.row?.daily_stats[0].searches ? params.row?.daily_stats[0].service_words_searches / params.row?.daily_stats[0].searches : 0,
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value * 100)
                return valueFormatted + "%"
            }

        },
        {
            field: "median_keywords",
            headerName: "Med. Kwd",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 50,
            valueGetter: (params) => params.row?.daily_stats.length && params.row?.daily_stats[0].median_searches_by_keyword ? params.row?.daily_stats[0].median_searches_by_keyword : 0

        },
        {
            field: "tags",
            headerName: "Tags",
            type: 'string',
            editable: false,
            hide: true,
            flex: 0.4,
            minWidth: 100,
            valueGetter: (params) => params.row?.daily_stats.length ? params.row?.daily_stats[0].demand_feed.tags : 0

        },
        {
            field: "type",
            headerName: "Type",
            type: 'string',
            editable: false,
            flex: 0.2,
            minWidth: 50,
            valueGetter: (params) => {

                if (params.row?.daily_stats.length && params.row?.daily_stats[0].demand_feed.tags) {
                    const tags = params.row?.daily_stats[0].demand_feed.tags
                    if (tags.search(/bhs/i) != -1) {
                        return "BHS"
                    } else if (tags.search(/n2s/i) != -1) {
                        return "N2S"
                    } else {
                        return "Unknown"
                    }
                }
                return "No Data"

            }

        },
        {
            field: "referers",
            headerName: "Referers",
            type: 'string',
            editable: false,
            flex: 0.4,
            minWidth: 100,
            valueGetter: (params) => {
                if (params.row?.daily_stats.length && params.row?.daily_stats[0].referers) {
                    const referers = JSON.parse(params.row?.daily_stats[0].referers)
                    const refs = Object.keys(referers).map(key => {

                        return key != "" ? key : "None"

                    });

                    return refs

                }
                return "No Data"

            },
            renderCell: (params) => {
                if (params.row?.daily_stats.length && params.row?.daily_stats[0].referers) {
                    const referers = JSON.parse(params.row?.daily_stats[0].referers)
                    let i = 0;
                    const refs = Object.keys(referers).map(key => {
                        let r
                        if (i < 2) {
                            r = <span>  {i > 0 && ", "}{key != "" ? key : "None"}</span>
                        } else if(i == 3) {
                            r = <span>{i > 0 && ", "}<a href={"#referers"} onClick={() => handleModal(params.row.id, 'referers')}
                                                        sx={{pl: 1}}>+{(Object.keys(referers).length - i)} </a></span>
                        }
                        ++i
                        return r


                    });

                    return (refs)
                }
            }

        },
        {
            headerName: "Actions",
            field: 'actions',
            type: 'actions',
            flex: 0.2,
            width: 50,
            getActions: (params) => [

                <GridActionsCellItem icon={<QueryStats/>} onClick={() => { setDetailsId(params.row.id); setOpenDetails(true); }} label="Open Details"/>]

        }
    ]


    let mainLayout = <><MainLayout>
        <Success successMessage={apiMessage} setSuccessMessage={setApiMessage}>
            {apiMessage?.message}
        </Success>


        <BasicModalTable rows={rowsModalTable} columns={columnsModalTable} open={openModal} setOpen={setOpenModal}
                         loading={loadingModal} setLoading={setLoadingModal}/>

        <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
            <Paper sx={{p: 2}}>
                <Title>Supply Admin</Title>
                <Stack direction="row" spacing={2}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>

                    <DatePicker
                        label="Pick a Date"
                        value={startDate}
                        onChange={(newValue) => {
                            let tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
                            let date = (new Date(newValue - tzoffset)).toISOString().slice(0, -1);
                            setStartDate(date);
                            loadStats({start_date: date})

                        }}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider>
                <IconButton onClick={() => loadStats({start_date: startDate})}>
                    <Refresh/>
                </IconButton>
                </Stack>
                <DataGrid
                    rows={!loading ? supplyStats : []}
                    columns={columns}
                    pageSize={pageSize}
                    initialState={{
                        sorting: {
                            sortModel: [{field: 'searches', sort: 'desc'}],
                        },
                    }}
                    hideFooter={true}

                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    autoHeight={true}
                    disableSelectionOnClick
                    rowsPerPageOptionsSkeleton
                    components={{
                        LoadingOverlay: LoadingSkeleton,
                        Toolbar: GridToolbar,

                    }}
                    componentsProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: {debounceMs: 500},
                        },
                    }}


                    sx={{
                        mt: 2,
                        mb: 2,
                        minHeight: 600,
                    }}
                    density={"compact"}

                    loading={loading}
                />

                        <SupplyFeedDetailsTable id={detailsId} open={openDetails} setOpen={setOpenDetails}/>


            </Paper>



        </Container>

    </MainLayout></>;
    return mainLayout
}


export default SupplyAdmin